import React, { useState, useEffect } from 'react';
import WorksheetTabs from './WorksheetTabs';
import Spreadsheet from './Spreadsheet';

// Use the PHP backend URL directly
const API_BASE_URL = 'http://spreadsheets.isilverstar.in/api';

const UserView = () => {
  const [worksheets, setWorksheets] = useState([]);
  const [activeWorksheetId, setActiveWorksheetId] = useState(null);
  const [activeWorksheet, setActiveWorksheet] = useState(null);
  const [cells, setCells] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch all worksheets
  useEffect(() => {
    const fetchWorksheets = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/worksheets`);
        if (!response.ok) {
          throw new Error('Failed to fetch worksheets');
        }
        const data = await response.json();
        setWorksheets(data);
        
        // Set the first worksheet as active if none is selected
        if (data.length > 0 && !activeWorksheetId) {
          setActiveWorksheetId(data[0].id);
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchWorksheets();
  }, []);

  // Fetch worksheet data when active worksheet changes
  useEffect(() => {
    if (!activeWorksheetId) return;

    const fetchWorksheetData = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${API_BASE_URL}/worksheets/${activeWorksheetId}`);
        if (!response.ok) {
          throw new Error('Failed to fetch worksheet data');
        }
        const data = await response.json();
        setActiveWorksheet(data.worksheet);
        setCells(data.cells);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchWorksheetData();
  }, [activeWorksheetId]);

  const handleSelectWorksheet = (worksheetId) => {
    setActiveWorksheetId(worksheetId);
  };

  // Disable right-click context menu
  useEffect(() => {
    const handleContextMenu = (e) => {
      e.preventDefault();
    };

    document.addEventListener('contextmenu', handleContextMenu);
    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
    };
  }, []);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative" role="alert">
        <strong className="font-bold">Error: </strong>
        <span className="block sm:inline">{error}</span>
      </div>
    );
  }

  return (
    <div className="user-view p-6" >
      
      {worksheets.length > 0 ? (
        <>
          <WorksheetTabs 
            worksheets={worksheets} 
            activeWorksheetId={activeWorksheetId} 
            onSelectWorksheet={handleSelectWorksheet} 
          />
          
          {activeWorksheet && (
            <div>
              <h2 className="text-xl font-semibold mb-4 text-gray-700">{activeWorksheet.name}</h2>
              <Spreadsheet worksheet={activeWorksheet} cells={cells} apiBaseUrl={API_BASE_URL} />
            </div>
          )}
        </>
      ) : (
        <div className="bg-blue-100 border border-blue-400 text-blue-700 px-4 py-3 rounded relative" role="alert">
          <strong className="font-bold">No worksheets found. </strong>
          <span className="block sm:inline">Please create a worksheet in the admin panel.</span>
        </div>
      )}
    </div>
  );
};

export default UserView;